import { render, staticRenderFns } from "./sourceSetting.vue?vue&type=template&id=2ab37fe8&scoped=true"
import script from "./sourceSetting.vue?vue&type=script&lang=ts"
export * from "./sourceSetting.vue?vue&type=script&lang=ts"
import style0 from "./sourceSetting.vue?vue&type=style&index=0&id=2ab37fe8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab37fe8",
  null
  
)

export default component.exports